import React, { useEffect, useState } from "react";
import PlusIcon from "../../assets/icons/plus";
import Popup from "../Common/Popup";
import Input from "../Common/CustomInput";
import HolidayTable from "../Common/HolidayTable";
import useApiLoader from "../../Utils/useApiLoader";
import Loader from "../Loader/Loader";
import api from "../../setupMiddleware";
import { ToastContainer, toast, Bounce } from "react-toastify";
import CustomSelect from "../Common/CustomSelect";

const HolidayManagement = () => {
  const [open, setOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [holidayData, setHolidayData] = useState([]);
  const [holiday, setHoliday] = useState({
    holiday_date: "",
    title: "",
    location_id: "",
    year: "",
  });
  const { holiday_date, title, location_id, year } = holiday;
  console.log(holiday);
  const [holidayEdit, setHolidayedit] = useState({});
  const [locationData, setLocationData] = useState([]);
  const locationOptions = locationData?.map((loc) => ({
    label: loc.name,
    value: loc.id,
  }));

  const loading = useApiLoader();

  const getAllHolidays = async () => {
    api.get("/api/public-holidays").then((res) => {
      if (res && res.status === 200) {
        setHolidayData(res.data);
        setHoliday({
          holiday_date: "",
          title: "",
          location_id: "",
          year: "",
        });
        setOpen(false);
        setEditOpen(false);
        setDeleteOpen(false);
        setHolidayedit({});
      }
    });
  };

  const addNewHoliday = async () => {
    api
      .post("/api/public-holidays", { holiday_date, title, location_id, year })
      .then((res) => {
        if (res && res.status === 201) {
          toast.success(res.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
          getAllHolidays();
        }
      })
      .catch((err) => {
        if (err) {
          alert(err.response?.data?.message);
        }
      });
  };

  const updateHoliday = async () => {
    api
      .put(`/api/public-holidays/${holidayEdit?.id}`, {
        holiday_date: holidayEdit?.holiday_date,
        title: holidayEdit?.title,
        location_id: holidayEdit?.location_id,
        year: holidayEdit?.year,
      })
      .then((res) => {
        if (res && res.status === 200) {
          toast.success(res.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
          getAllHolidays();
        }
      })
      .catch((err) => {
        if (err) {
          alert(err.response?.data?.errors?.name[0]);
        }
      });
  };

  const deleteHoliday = async () => {
    api
      .delete(`/api/public-holidays/${holidayEdit?.id}`)
      .then((res) => {
        if (res && res.status === 200) {
          toast.success(res.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
          getAllHolidays();
        }
      })
      .catch((err) => {
        if (err) {
          alert(err.response?.data?.errors?.name[0]);
        }
      });
  };

  const getAllLocation = async () => {
    api.get("/api/locations").then((res) => {
      if (res && res.status === 200) {
        setLocationData(res.data?.data);
      }
    });
  };

  const handleEditHoliday = (val) => {
    setHolidayedit(val);
    setEditOpen(true);
  };

  const handleDeleteHoliday = (val) => {
    setHolidayedit(val);
    setDeleteOpen(true);
  };

  useEffect(() => {
    getAllHolidays();
    getAllLocation();
  }, []);

  return (
    <>
      {loading && <Loader opacity={90} fullscreen />}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full mx-auto px-4 py-3 gap-4">
        {/* Left Content */}
        <p>
          <span className="block text-xl sm:text-2xl font-medium text-[#de2b26]">
            Holiday Management
          </span>
          <span className="block text-sm text-[#142b70]/50">
            Manage All Holidays
          </span>
        </p>

        {/* Right Button */}
        <div className="flex">
          <button
            onClick={() => setOpen(true)}
            className="flex items-center gap-2 px-4 py-2 rounded bg-[#de2b26] hover:bg-[#c30f0a] transition text-white text-sm font-medium"
          >
            <PlusIcon iconClass="w-4 h-4" color="#ffffff" />
            Add New Holiday
          </button>
          <Popup
            isOpen={open}
            onClose={() => setOpen(false)}
            title="Add New Holiday"
          >
            <div className="flex flex-col gap-6 mt-[30px]">
              <div className="flex flex-col gap-2">
                <p className="text-sm text-[#142b70]/80">Holiday Date</p>
                <div className="relative">
                  <Input
                    type="date"
                    placeholder="HR"
                    value={holiday_date}
                    onChange={(e) =>
                      setHoliday({ ...holiday, holiday_date: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="flex flex-col gap-2">
                <p className="text-sm text-[#142b70]/80">Holiday Title</p>
                <div className="relative">
                  <Input
                    type="text"
                    placeholder="Title"
                    value={title}
                    onChange={(e) =>
                      setHoliday({ ...holiday, title: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="flex flex-col gap-2">
                <p className="text-sm text-[#142b70]/80">Location</p>
                <CustomSelect
                  options={locationOptions}
                  value={location_id}
                  placeholder="Location"
                  width="w-full"
                  height="h-[46px]"
                  fontSize="14px"
                  onChange={(op) =>
                    setHoliday({
                      ...holiday,
                      location_id: op.value,
                    })
                  }
                />
              </div>
              <div className="flex flex-col gap-2">
                <p className="text-sm text-[#142b70]/80">Year</p>
                <div className="relative">
                  <Input
                    type="number"
                    placeholder="Year"
                    value={year}
                    onChange={(e) =>
                      setHoliday({ ...holiday, year: e.target.value })
                    }
                  />
                </div>
              </div>
            </div>
            {/* Footer */}
            <div className="flex justify-end gap-4">
              <button
                onClick={() => setOpen(false)}
                className="px-10 py-3.5 rounded-md border border-[#de2b26] text-[#de2b26] font-medium"
              >
                Cancel
              </button>
              <button
                onClick={addNewHoliday}
                disabled={
                  holiday_date && title && location_id && year ? false : true
                }
                className="px-10 py-3.5 rounded-md bg-[#de2b26] text-white font-medium disabled:opacity-50"
              >
                Add Holiday
              </button>
            </div>
          </Popup>
          {/* Edit Popup */}
          <Popup
            isOpen={editOpen}
            onClose={() => setEditOpen(false)}
            title="Edit Holiday"
          >
            <div className="flex flex-col gap-6 mt-[30px]">
              <div className="flex flex-col gap-2">
                <p className="text-sm text-[#142b70]/80">Holiday Date</p>
                <div className="relative">
                  <Input
                    type="date"
                    placeholder="HR"
                    value={holidayEdit?.holiday_date}
                    onChange={(e) =>
                      setHolidayedit({
                        ...holidayEdit,
                        holiday_date: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="flex flex-col gap-2">
                <p className="text-sm text-[#142b70]/80">Holiday Title</p>
                <div className="relative">
                  <Input
                    type="text"
                    placeholder="Title"
                    value={holidayEdit?.title}
                    onChange={(e) =>
                      setHolidayedit({ ...holidayEdit, title: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="flex flex-col gap-2">
                <p className="text-sm text-[#142b70]/80">Location</p>
                <CustomSelect
                  options={locationOptions}
                  value={holidayEdit?.location_id}
                  placeholder="Location"
                  width="w-full"
                  height="h-[46px]"
                  fontSize="14px"
                  onChange={(op) =>
                    setHolidayedit({
                      ...holidayEdit,
                      location_id: op.value,
                    })
                  }
                />
              </div>
              <div className="flex flex-col gap-2">
                <p className="text-sm text-[#142b70]/80">Year</p>
                <div className="relative">
                  <Input
                    type="number"
                    placeholder="Year"
                    value={holidayEdit?.year}
                    onChange={(e) =>
                      setHolidayedit({ ...holidayEdit, year: e.target.value })
                    }
                  />
                </div>
              </div>
            </div>
            {/* Footer */}
            <div className="flex justify-end gap-4">
              <button
                onClick={() => setEditOpen(false)}
                className="px-10 py-3.5 rounded-md border border-[#de2b26] text-[#de2b26] font-medium"
              >
                Cancel
              </button>
              <button
                onClick={updateHoliday}
                disabled={
                  holidayEdit?.holiday_date &&
                  holidayEdit?.title &&
                  holidayEdit?.location_id &&
                  holidayEdit?.year
                    ? false
                    : true
                }
                className="px-10 py-3.5 rounded-md bg-[#de2b26] text-white font-medium disabled:opacity-50"
              >
                Update Holiday
              </button>
            </div>
          </Popup>

          {/* Delete Popup */}
          <Popup
            isOpen={deleteOpen}
            onClose={() => setDeleteOpen(false)}
            title="Delete Holiday"
          >
            <div className="flex flex-col gap-6 mt-[30px]">
              <div className="flex flex-col gap-2">
                <p className="text-sm text-[#142b70]/80">
                  Are you sure and want to delete <b>{holidayEdit?.title}</b>{" "}
                  Holiday?
                </p>
              </div>
            </div>

            <div className="flex justify-end gap-4">
              <button
                onClick={() => setDeleteOpen(false)}
                className="px-10 py-3.5 rounded-md border border-[#de2b26] text-[#de2b26] font-medium"
              >
                Cancel
              </button>
              <button
                onClick={deleteHoliday}
                className="px-10 py-3.5 rounded-md bg-[#de2b26] text-white font-medium disabled:opacity-50"
              >
                Delete Holiday
              </button>
            </div>
          </Popup>
        </div>
      </div>

      <div className="w-full mx-auto px-4 py-3 relative">
        <div className="w-full mx-auto px-4 py-3 relative rounded-xl bg-white border border-[#a48572]/10">
          <div className="flex flex-col justify-start items-start gap-[20px]">
            <div className="flex flex-col justify-start items-start flex-grow-0 flex-shrink-0 relative gap-5">
              <p className="flex-grow-0 flex-shrink-0 text-base font-medium text-left text-[#142b70]">
                All Holidays
              </p>
            </div>
            <HolidayTable
              data={holidayData}
              handleEdit={handleEditHoliday}
              handleDelete={handleDeleteHoliday}
            />
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default HolidayManagement;
